export enum PriceContext {
  PRODUCT_INTRO,
  PRODUCT_COMBO_OPTION,
}

export enum CompareAtPriceDisplay {
  STRIKETHROUGH = "strikethrough",
  VALUE = "value",
}
